import { render, staticRenderFns } from "./disposalMain.vue?vue&type=template&id=0ceeb2ec&scoped=true"
import script from "./disposalMain.vue?vue&type=script&lang=js"
export * from "./disposalMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_6d50957d97179d0c2dc3f7fe111d18c4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ceeb2ec",
  null
  
)

export default component.exports